export const postData = [
	{
		category: "Learning",
		subtitle: "about your eczema",
		slugs: ["what-is-eczema", "what-triggers-my-eczema", "managing-eczema"],
	},
	{
		category: "Developing",
		subtitle: "your personal eczema management plan",
		slugs: [
			"eliminate-any-potential-triggers",
			"experiment-with-what-works-and-what-doesnt",
			"equip-yourself-with-the-right-support",
		],
	},
	{
		category: "Engaging",
		subtitle: "with the ECZE community (you are not alone!)",
		slugs: [
			"becs-personal-eczema-journey",
			"supporting-a-loved-one-with-eczema",
			"encouragements-for-eczema-sufferers",
		],
	},
]
